var SECOND = 1000;
var MINUTE = 60 * SECOND;
var HOUR = 60 * MINUTE;
var DAY = 24 * HOUR;
var DAYS_PER_WEEK = 7;
var MONTHS_PER_YEAR = 12;
var Month = /*#__PURE__*/function (Month) {
  Month[Month["JANUARY"] = 0] = "JANUARY";
  Month[Month["FEBRUARY"] = 1] = "FEBRUARY";
  Month[Month["MARCH"] = 2] = "MARCH";
  Month[Month["APRIL"] = 3] = "APRIL";
  Month[Month["MAY"] = 4] = "MAY";
  Month[Month["JUNE"] = 5] = "JUNE";
  Month[Month["JULY"] = 6] = "JULY";
  Month[Month["AUGUST"] = 7] = "AUGUST";
  Month[Month["SEPTEMBER"] = 8] = "SEPTEMBER";
  Month[Month["OCTOBER"] = 9] = "OCTOBER";
  Month[Month["NOVEMBER"] = 10] = "NOVEMBER";
  Month[Month["DECEMBER"] = 11] = "DECEMBER";
  return Month;
}({});
var DayOfWeek = /*#__PURE__*/function (DayOfWeek) {
  DayOfWeek[DayOfWeek["SUNDAY"] = 0] = "SUNDAY";
  DayOfWeek[DayOfWeek["MONDAY"] = 1] = "MONDAY";
  DayOfWeek[DayOfWeek["TUESDAY"] = 2] = "TUESDAY";
  DayOfWeek[DayOfWeek["WEDNESDAY"] = 3] = "WEDNESDAY";
  DayOfWeek[DayOfWeek["THURSDAY"] = 4] = "THURSDAY";
  DayOfWeek[DayOfWeek["FRIDAY"] = 5] = "FRIDAY";
  DayOfWeek[DayOfWeek["SATURDAY"] = 6] = "SATURDAY";
  return DayOfWeek;
}({});

export { DAY, DAYS_PER_WEEK, DayOfWeek, HOUR, MINUTE, MONTHS_PER_YEAR, Month, SECOND };
//# sourceMappingURL=constants.js.map
